import React, { useCallback } from "react";
import {
  updateHighlightingRules,
  addHighlightingRule,
  updateHighlightingRule,
  removeHighlightingRule
} from "views/logic/slices/highlightActions";
import HighlightingRules from "views/components/sidebar/highlighting/HighlightingRules";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useProductName from "brand-customization/useProductName";
const ViewsHighlightingRules = () => {
  const dispatch = useViewsDispatch();
  const productName = useProductName();
  const onUpdateRules = useCallback(
    (newRules) => dispatch(updateHighlightingRules(newRules)).then(() => {
    }),
    [dispatch]
  );
  const onCreateRule = useCallback(
    (newRule) => dispatch(addHighlightingRule(newRule)).then(() => {
    }),
    [dispatch]
  );
  const onUpdateRule = useCallback(
    (targetRule, field, value, condition, color) => dispatch(updateHighlightingRule(targetRule, { field, value, condition, color })).then(() => {
    }),
    [dispatch]
  );
  const onDeleteRule = useCallback(
    (rule) => dispatch(removeHighlightingRule(rule)).then(() => {
    }),
    [dispatch]
  );
  const description = `Search terms and field values can be highlighted. Highlighting your search query in the results can be enabled/disabled in the ${productName} server config.Any field value can be highlighted by clicking on the value and selecting "Highlight this value".
If a term or a value has more than one rule, the first matching rule is used.`;
  return /* @__PURE__ */ React.createElement(
    HighlightingRules,
    {
      description,
      onDeleteRule,
      onUpdateRules,
      onCreateRule,
      onUpdateRule
    }
  );
};
export default ViewsHighlightingRules;
